var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleIconsNpiFaded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44.7422C34.1503 44.7422 44 34.8925 44 22.7422C44 10.5919 34.1503 0.742188 22 0.742188C9.84974 0.742188 0 10.5919 0 22.7422C0 34.8925 9.84974 44.7422 22 44.7422ZM12.008 11.3427V33.7427H16.136V18.577L28.488 33.7427H31.912V11.3427H27.784V26.5083L15.432 11.3427H12.008Z",
    fill: "#A9ADCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsNpiFaded);
export default __webpack_public_path__ + "static/media/simple-icons_npi_faded.2c73924931c2100059bc7588b79cfdab.svg";
export { ForwardRef as ReactComponent };